import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Module} from '../../models/models';
import {Translation} from '../../models/translation';
import {UserService} from '../../services/user.service';
import Swal from 'sweetalert2';
import {sha256} from 'js-sha256';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.css']
})
export class SideNavigationComponent implements OnInit {

  public translation: Translation;
  public modules: Module[] = [];
  public tempPw2: string;
  public tempPw3: string;

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.loadModules();
  }

  loadModules() {
    if (JSON.parse(sessionStorage.getItem('Modules')).length !== 0) {
      for (const module of JSON.parse(sessionStorage.getItem('Modules'))) {
        const newModule = new Module();
        switch (module.ModuleId) {
          case 10: newModule.ModuleName = this.translation.Transport; break;
          case 20: newModule.ModuleName = this.translation.WheelNews; break;
          case 30: newModule.ModuleName = this.translation.Cartec; break;
          case 40: newModule.ModuleName = this.translation.AirportParking; break;
          case 50: newModule.ModuleName = this.translation.Fotobox; break;
          case 60: newModule.ModuleName = 'Schadensverwaltung'; break;
          case 70: newModule.ModuleName = this.translation.Administration; break;
          case 80: newModule.ModuleName = this.translation.StatusCheck; break;
        }
        newModule.ForwardLink = module.ForwardLink;
        this.modules.push(newModule);
      }
    }
  }

  navigate(forwardLink: string) {
    this.router.navigate([forwardLink]);
  }

  logout() {
    sessionStorage.clear();
    this.navigate('/login');
  }

  passwordChange() {
    this.userService.getUserById(+sessionStorage.getItem('UserId')).subscribe(response => {
      if (response.Ok) {
        Swal.mixin({
          input: 'password',
          inputValidator: (value) => {
            if (response.Obj.Password !== sha256(value)) { return this.translation.OldPasswordNotCorrectMessage; }
            return !value && this.translation.YouHaveToEnterAPassword;
          },
          confirmButtonColor: '#CC0000',
          allowOutsideClick: false,
          showCancelButton: true,
          showConfirmButton: true,
          reverseButtons: true,
          confirmButtonText: this.translation.Next + ' &rarr;',
          progressSteps: ['1', '2', '3']
        }).queue([
          {
            title: this.translation.PasswordChange,
            text: this.translation.OldPassword,
            inputValidator: (value) => {
              if (response.Obj.Password !== sha256(value)) { return this.translation.OldPasswordNotCorrectMessage; }
              return !value && this.translation.YouHaveToEnterAPassword;
            },
            currentProgressStep: '0'
          },
          {
            title: this.translation.PasswordChange,
            text: this.translation.NewPassword,
            inputValidator: (value) => {
              this.tempPw2 = value;
              return !value && this.translation.YouHaveToEnterAPassword;
            },
            currentProgressStep: '1'
          },
          {
            title: this.translation.PasswordChange,
            text: this.translation.RepeatPassword,
            inputValidator: (value) => {
              this.tempPw3 = value;
              if (this.tempPw2 !== this.tempPw3) { return this.translation.RepeatPasswordNotCorrectMessage; }
              return !value && this.translation.YouHaveToRepeatTheNewPassword;
            },
            currentProgressStep: '2'
          }
        ]).then((result: any) => {
          if (result.value) {
            response.Obj.Password = this.tempPw2;
            this.userService.updateUser(response.Obj.UserId, response.Obj).subscribe(responseUser => {
              if (responseUser.Ok) {
                if (responseUser.Obj) { Swal.fire({title: this.translation.PasswordChanged, icon: 'success', confirmButtonColor: '#CC0000'}); }
              } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
              if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
            }, error => { this.toast.fire(this.translation.InternalServerError); });
          }
        });
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }
}
